import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../Home/Home';
import InfraestructuraRedPage from '../Tech/NetworkInfrastructure/NetworkInfrastructurePage';
import SoftwareConsulting from '../Tech/SoftwareConsulting/SoftwareConsulting';
import Solutions from '../Solutions/Solutions';
import Technology from '../Tech/Technology';
import About from '../About/About';
import Contact from '../Contact/Contact';
import PrivacyPolicy from '../PrivacyPolicy/PrivacyPolicy';
import TermsAndConditions from '../TermsAndConditions/TermsAndConditions';

const Content = () => {
  return (
    <main className="flex-grow">
      <Routes>
        <Route path="/prueba" element={<Home />} />
        <Route path="/" element={<Solutions />} />
        {/* <Route path="/tech" element={ <Technology />} /> */}
        {/* <Route path="/tech/network-infrastructure" element={ <InfraestructuraRedPage />} /> */}
        {/* <Route path="/tech/software-consulting" element={ <SoftwareConsulting />} /> */}
        {/* <Route path="/solutions" element={ <Solutions />} /> */}
        <Route path="/about-us" element={ <About />} />
        <Route path="/contact" element={ <Contact/>} />
        <Route path="/politica-de-privacidad" element={ <PrivacyPolicy />} />
        <Route path="/terminos-y-condiciones" element={ <TermsAndConditions />} />
      </Routes>
    </main>
  );
};

export default Content;